import { DialogContent, DialogHeader } from "../../../../components/ui/dialog";
import { useToast } from "../../../../hooks/use-toast";

import Spinner from "../../../../components/spinner.components";
import { useNavigate, useParams } from "react-router-dom";
import { handleHttpError } from "../../../../utils/utils";
import { Button } from "../../../../components/ui/button";
import { DialogClose } from "@radix-ui/react-dialog";
import { useEndCampaignAdminHttp } from "../../../../hooks/http/admin/campaigns/end-campaign.admin.http";
import { DateTime } from "luxon";

export const EndCampaignModalPartial: React.FunctionComponent = () => {
	const { execute: endCampaignHttp, fetching: endingCampaign } =
		useEndCampaignAdminHttp();
	const { toast } = useToast();

	const { campaignId } = useParams();

    const navigate = useNavigate();

	async function endCampaign() {
		if (!campaignId) {
			return;
		}
		const currentDate = DateTime.local().toJSDate();

		const response = await endCampaignHttp({
			body: {endDate: currentDate},
			pathParams: { id: campaignId },
		});
		if (!response.success) {
			return handleHttpError(response, toast);
		}
		toast({
			content: "Campaign ended successfully",
			toastType: "success",
		});

        navigate(`/admin/campaigns/${campaignId}/campaign-metrics`);
        
	}
	return (
		<DialogContent className="flex max-w-2xl flex-col items-center gap-16 border-border w-full text-center text-primary py-10">
			<DialogHeader className="flex items-center gap-2 w-full ">
				<h2 className="font-semibold text-3xl text-center">
					Are you sure you wanna end this
					<br />  campaign ?
				</h2>
				<p className="font-semibold text-center text-secondary">
                The campaign moves to view validation state
				</p>
			</DialogHeader>
			<div className="flex items-center justify-center gap-5 w-full">
				<DialogClose className="">
					<Button className="bg-tertiarybuttonbg px-20 py-8 border border-border w-56 font-semibold text-[18px]">
						Cancel
					</Button>
				</DialogClose>
				<Button
                    disabled={endingCampaign}
					onClick={endCampaign}
					className="bg-rejectbuttonbg border border-rejectbuttonborder px-20 py-8 w-56 font-semibold text-[18px] text-rejectbuttontext"
				>
					{endingCampaign ? <Spinner width={20} /> : "End campaign"}
				</Button>
			</div>
		</DialogContent>
	);
};
